import type { MouseEvent } from 'react';

/**
 * Hover text for a `truncate`d element, and only when it is actually cutting the text off.
 *
 * A plain `title` is simpler, but it fires on every row — so a name that fits whole still raises a
 * tooltip repeating what the reader can already see. Whether a box is truncating is a layout fact,
 * not a prop: the same name fits in a wide dialog and not in a narrow one. So the check happens at
 * the moment the pointer arrives, which is early enough — the browser waits out its own delay before
 * it draws the tooltip, and it reads the attribute after that.
 *
 * Attach as `onMouseEnter`; the element's own text is what it shows.
 */
export function titleWhenTruncated(event: MouseEvent<HTMLElement>): void {
  const element = event.currentTarget;
  if (element.scrollWidth > element.clientWidth) {
    element.title = element.textContent ?? '';
  } else {
    element.removeAttribute('title');
  }
}
